import axiosInstance from '../../axios';
import { rejectError } from '../../helper';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    getChannelDistribs({ commit }) {
      return axiosInstance.get('/api/3/channel-distribs?$expand=*')
        .then(result => result.data.data)
        .catch(error => rejectError(error));
    },
    // eslint-disable-next-line no-unused-vars
    getChannelDistrib({ commit }, id) {
      return axiosInstance.get(`/api/3/channel-distribs/${id}?$expand=*`)
        .then(result => result.data.data)
        .catch(error => rejectError(error));
    },
    // eslint-disable-next-line no-unused-vars
    createChannelDistrib({ dispatch }, cd) {
      return axiosInstance({
        method: 'POST',
        url: '/api/3/channel-distribs',
        data: cd,
      })
        .then(result => result.data.data)
        .catch(error => rejectError(error));
    },
    // eslint-disable-next-line no-unused-vars
    updateChannelDistrib({ dispatch }, cd) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/3/channel-distribs/${cd.id}`,
        data: cd,
      })
        .then(result => result.data.data)
        .catch(error => rejectError(error));
    },
    // eslint-disable-next-line no-unused-vars
    removeChannelDistrib({ dispatch }, id) {
      return axiosInstance({
        method: 'DELETE',
        url: `/api/3/channel-distribs/${id}`,
      })
        .then(result => result.data)
        .catch(error => rejectError(error));
    },
  },
};
